module.exports = __webpack_public_path__ + "0956f1f0.svg";